import React from "react";
import './00TopEducationLinks.css';
import MainMenuArray from "../00LayoutMain/MainMenu";
import ButtonAll from "../Components/Buttons/ButtonAll";

const TopEducationMenu = (lang) => MainMenuArray[5].Submenu.map(function(MenuElement,index) {
        return (
            <ButtonAll ssilka={MenuElement.href} lang = {lang} className='ButtonEducationTop' label={MenuElement.Name[lang]}   key={index} activeClassName='ButtonEducationTopActive'/>
        )}
);

function TopEducationLinks(props) {
    return <div  className='TopEducationLinks' >{TopEducationMenu(props.lang)}</div>
}
export default TopEducationLinks